module.exports = __webpack_public_path__ + "img/sm.0e9780f1.png";